import { checkNotAdmin } from "./utils";

export function formatFollowerCount(count) {
  if (count >= 1_000_000) {
    return (count / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  } else if (count >= 1_000) {
    return (count / 1_000).toFixed(1).replace(/\.0$/, "") + "k";
  } else {
    return count.toString();
  }
}

// =============================================================================
// THIS FUNCTION CONVERTS THE NORMAL NUMBER INTO THE RESPECTIVE CURRENCY FORMAT
// =============================================================================
export function formatToINRCurrency(num) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(num);
}

export const defaultPath = checkNotAdmin() ? "/feed" : "/dashboard";

export const downloadFile = async (response, fileName = "export.xlsx") => {
  try {
    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(blobUrl);
    console.log("✅ File download triggered:", fileName);
  } catch (error) {
    console.error("❌ Error downloading file:", error);
  }
};

export function formatDateToReadable(dateString) {
  const date = new Date(dateString);
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleString("en-GB", options).split(",");
}

// Helper function to check if current date is within 7 days of end
export const isWithin7DaysOfEnd = (endDate) => {
  if (!endDate) return false;
  const today = new Date();
  const end = new Date(endDate);
  const diffInDays = (end - today) / (1000 * 60 * 60 * 24);
  return diffInDays <= 7;
};

export const SelectStyles = {
  control: (provided) => ({
    ...provided,
    border: " 1px solid #c8cdf3",
    cursor: "pointer",
    backgroundColor: "white",
    boxShadow: "none",
    outline: "none",
    // border: "none",
    minHeight: "35px",
    // height: "28px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "black",
    fontWeight: "400",
    fontSize: "0.9rem",
  }),
  menuList: (provided) => ({
    ...provided,
    backgroundColor: "#F3F5FD",
    paddingTop: "0px",
    paddingBottom: "0px",
    borderRadius: "3px",
  }),
  option: (provided) => ({
    ...provided,
    padding: "3px 8px",
    cursor: "pointer",
    fontSize: "0.9rem",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#c8cdf3",
    padding: "4px 6px 0px 0px",
    transition: "all 0.2s ease",
  }),
};
